import React from 'react'
export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5483_9745)">
      <g clip-path="url(#clip1_5483_9745)">
        <rect width="24" height="24" rx="12" fill="#151718" />
        <path
          d="M7.06215 11.6658L6.91785 13.4936H7.471L7.31468 11.6658L7.20645 10.1266H7.17038L7.06215 11.6658Z"
          fill="#ECEDEE"
        />
        <path
          d="M12.0913 12.1829H12.4039C12.6444 12.1829 12.7406 11.9664 12.7406 11.5816V9.39305C12.7406 8.99623 12.6444 8.77977 12.4039 8.77977H12.0913V12.1829Z"
          fill="#ECEDEE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M-4.67174 0C-4.77335 0 -4.85571 0.0823656 -4.85571 0.183968V24.7277C-4.85571 24.8293 -4.77335 24.9116 -4.67175 24.9116H27.4999C27.6015 24.9116 27.6838 24.8293 27.6838 24.7277V0.183968C27.6838 0.0823653 27.6015 0 27.4999 0H-4.67174ZM6.40077 7.70954H8.06023L9.13046 16.6081H7.72353L7.5672 14.6721H6.82165L6.66532 16.6081H5.33054L6.40077 7.70954ZM12.0792 16.6081H10.6483V7.70954H12.5242C13.5463 7.70954 14.1716 8.3108 14.1716 9.39305V11.5816C14.1716 12.6518 13.5463 13.2531 12.5242 13.2531H12.0792V16.6081ZM15.82 7.70954V16.6081H18.6098V15.4296H17.2509V12.6999H18.4655V11.5215H17.2509V8.888H18.6098V7.70954H15.82Z"
          fill="#ECEDEE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5483_9745">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_5483_9745">
        <rect width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
